import React from 'react';
import Field from './Field'
import Warning from '../../common/Warning';
import Information from '../../common/Information';

export default class FieldCheckbox extends Field {
    static defaultProps = {
        renderLabel: true
    }

    constructor(props) {
        super(props)

        this.labelRef = React.createRef()
        this.state = {
            checked: props.value
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({checked: nextProps.value})
    }

    onChange = e => {
        this.setState({checked: !this.state.checked})
        this.props.onChange(!this.state.checked)
    }

    onKeyUp = e => {
        if (e.which === 9) {
            this.labelRef.current.focus()
            this.onTabFocus(e)
        }
    }

    renderWarning = () => {
        if (this.props.warning != undefined) {
            return (
                <Warning warning={this.props.warning}/>
            )
        }

        return (<React.Fragment></React.Fragment>);
    }
    renderInformation = () => {
        if (this.props.information != undefined) {
            return (
                <Information information={this.props.information}/>
            )
        }

        return (<React.Fragment></React.Fragment>);
    }

    renderField() {
        let id = this.generateUniqueId()
        return (
            <React.Fragment>
                <div className="configuration-editor-input-wrapper" data-checkbox>
                    <input
                        id={id}
                        type="checkbox"
                        checked={this.state.checked}
                        onChange={this.onChange}
                        onKeyUp={this.onKeyUp}
                        disabled={this.props.disabled}
                    />
                    <label tabIndex="0" htmlFor={id} title={this.props.title}
                           ref={this.labelRef}>{this.props.renderLabel ? this.props.label : ''}</label>
                    {this.renderWarning()}
                    {this.renderInformation()}
                </div>

            </React.Fragment>
        )
    }
}